// This is the article's editorial review date, not a build/deployment date.
// The Contentful node retains the original publication date and guide listing.
const uvPrintingGuide = {
  path: '/guides/what-is-uv-printing/',
  reviewedDate: '2026-09-11',
  reviewedDateLabel: 'September 11, 2026',
}

module.exports = { uvPrintingGuide }
